import apiService from './api';
import { DashboardStatsDTO } from '../types/dashboard'; // Предполагаем, что этот DTO будет в types/dashboard.ts

const DASHBOARD_BASE_PATH = '/dashboard';

export const dashboardService = {
  getPlatformStats: async (): Promise<DashboardStatsDTO> => {
    const response = await apiService.get<DashboardStatsDTO>(`${DASHBOARD_BASE_PATH}/stats`);
    return response.data;
  },
};

export const { getPlatformStats } = dashboardService;
